import {useQuery} from "@apollo/client";
import {ServicesQuery, GET_SERVICES} from "@App/graphql/queries";

export const useServices = (organization: number, service?: number, slug?: String) => {
    const {loading, data, error} = useQuery<ServicesQuery>(GET_SERVICES, {
        variables: {
            organization,
            service,
            slug
        }
    })

    return {
        loading: loading,
        error: error,
        services: data ? data.organization.services : null
    }
}


